import { useState } from "react";
import { api, ApiError } from "../api/client.js";
import { OAuthButtons } from "./OAuthButtons.jsx";

export function SignupForm({ audience, onSuccess, onGoToLogin }) {
  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    if (password.length < 10) {
      setError("Slaptažodis turi būti bent 10 simbolių.");
      return;
    }
    setSubmitting(true);
    try {
      const body =
        audience === "business" ? { email, password, companyName: companyName || undefined } : { email, password };
      await api.post(`/api/${audience}/auth/signup`, body);
      onSuccess();
    } catch (err) {
      if (err instanceof ApiError && err.body?.code === "email_taken") {
        setError("Šis el. paštas jau registruotas.");
      } else {
        setError("Nepavyko užregistruoti. Bandykite dar kartą.");
      }
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div>
      {audience === "casual" && (
        <>
          <OAuthButtons />
          <div style={{ textAlign: "center", fontSize: 12, color: "#9ca3af", marginBottom: 16 }}>arba</div>
        </>
      )}
      <form onSubmit={handleSubmit}>
        {audience === "business" && (
          <>
            <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#2C2C2C", marginBottom: 4 }}>
              Įmonės pavadinimas (nebūtina)
            </label>
            <input
              type="text"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              className="w-full px-3 py-2 mb-3 border border-gray-200 rounded-lg text-sm"
            />
          </>
        )}
        <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#2C2C2C", marginBottom: 4 }}>
          El. paštas
        </label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full px-3 py-2 mb-3 border border-gray-200 rounded-lg text-sm"
        />
        <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#2C2C2C", marginBottom: 4 }}>
          Slaptažodis (min. 10 simbolių)
        </label>
        <input
          type="password"
          required
          minLength={10}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full px-3 py-2 mb-4 border border-gray-200 rounded-lg text-sm"
        />

        {error && <div style={{ fontSize: 13, color: "#735DFF", marginBottom: 12 }}>{error}</div>}

        <button
          type="submit"
          disabled={submitting}
          className="w-full px-4 py-2 text-sm font-semibold rounded-lg bg-ral3000 text-white hover:bg-ral3000-dark disabled:opacity-60"
        >
          {submitting ? "Registruojama..." : "Registruotis"}
        </button>

        <div style={{ textAlign: "center", marginTop: 16, fontSize: 13, color: "#383853" }}>
          Jau turite paskyrą?{" "}
          <button type="button" onClick={onGoToLogin} style={{ color: "#735DFF", fontWeight: 600, background: "none", border: 0, cursor: "pointer" }}>
            Prisijungti
          </button>
        </div>
      </form>
    </div>
  );
}
